import { AutocompleteProps } from '@material-ui/lab/Autocomplete';
// eslint-disable-next-line
import React from 'react';
import { TextFieldProps } from 'formik-material-ui';
import { useGetRegions } from './hooks';
import AutocompleteDomicile from './AutocompleteDomicile';

type Props = {
  childrenFields: { fieldName: string }[];
} & TextFieldProps &
  Partial<AutocompleteProps>;

const RegionAutocomplete: React.FC<Props> = ({
  field,
  form,
  label,
  children,
  childrenFields = [],
  ...restProps
}) => {
  const { data, error, isLoading } = useGetRegions();
  return (
    <AutocompleteDomicile
      isLoading={isLoading}
      field={field}
      data={data}
      label={label}
      form={form}
      error={error}
      childrenFields={childrenFields}
      {...restProps}
    />
  );
};

export default RegionAutocomplete;
